import _ from 'lodash'
import DatasetsTextFilter from './datasets-text-filter'
import template from './datasets-rollup-filter-step1.hbs'
import selects from 'scoreboard/components/selects'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import datasetPaths from 'scoreboard/datasets/edit/dataset-paths'
import beginsEndsWithOperators from 'scoreboard/datasets/filters/begins-ends-with-operators'

const DatasetsRollupFilterStep1 = DatasetsTextFilter.extend({

	events: _.extend({}, DatasetsTextFilter.prototype.events, {
		'change [name=anotherTreeFieldIdentifier]': 'onChangeAnotherTreeFieldIdentifier'
	}),

	render: function() {
		this.$('.datasets-rollup-filter').html(template())
		if (this.options.filter.filterOn) {
			this.$('[name=filterOn]').val(this.options.filter.filterOn)
		}
		selects(this.$('[name=filterOn]'))

		this.renderAnotherTreeFieldIdentifierDropdown()

		this.$('[name=anotherTreeDescendants]').prop('checked', this.options.filter.anotherTreeDescendants)

		DatasetsTextFilter.prototype.render.apply(this, arguments)

		return this
	},

	renderAnotherTreeFieldIdentifierDropdown: function() {
		var fieldIdentifier = this.getFieldIdentifier()
		if (_.isEmpty(fieldIdentifier)) {
			return
		}

		var field = this.model.getFieldByFieldIdentifier(fieldIdentifier)
		var underlyingField = this.model.getUnderlyingField(field)
		var treeId = _.get(underlyingField, 'treeId')
		var otherRollupTrees = _.filter(this.model.get('fields'), f => {
			f = this.model.getUnderlyingField(f)
			return f.treeId == treeId && fieldIdentifier != f.id && f.datasetId == field.datasetId
		})
		let otherRollupVisibleLinkedFields = _.filter(this.model.get('visibleLinkedFields'), vlf => {
			let field = this.model.combinedFieldsById[vlf.fieldId]
			let underlyingField = this.model.getUnderlyingField(vlf.fieldId)
			let datasetId = datasetPaths.lastDatasetId(vlf.path)
			return underlyingField &&
				underlyingField.treeId == treeId &&
				(-1 * fieldIdentifier != vlf.id) &&
				datasetId == field.datasetId
		})

		_.invoke(this.markedField, 'remove')
		let selectedId = this.model.idsToFieldIdentifier({
			fieldId: _.get(this.options.filter, 'anotherTreeFieldId'),
			visibleLinkedFieldId: _.get(this.options.filter, 'anotherTreeVisibleLinkedFieldId')
		})
		this.markedField = renderFieldDropdown({
			el: this.$('[name=anotherTreeFieldIdentifier]'),
			dataset: this.model,
			allowedFieldIds: _.map(otherRollupTrees, 'id'),
			allowedVisibleLinkedFieldIds: _.map(otherRollupVisibleLinkedFields, 'id'),
			selectedId,
			required: true
		})
	},

	changeOperator: function() {
		DatasetsTextFilter.prototype.changeOperator.apply(this, arguments)

		// override the behavior for DatasetsTextFilter, and always hide the
		// "Add Equation" link
		this.$('.add-equation').addClass('is-not-displayed')

		var operator = this.$('[name=operator]').val()

		let showContainsAnySelect =
			operator === 'contains-any' || operator === 'contains-all' ||
			operator === 'does-not-contain-any' || operator === 'does-not-contain-all'

		let showFilterOn = showContainsAnySelect || beginsEndsWithOperators.includes(operator)

		this.$('.filter-on').toggleClass('is-not-displayed', !showFilterOn)

		this.$('[name=values], .select.control.is-any').toggleClass('is-not-displayed', !showContainsAnySelect)

		this.trigger('change-values-operator', 'contains-any', 'contains-all',
			'does-not-contain-any', 'does-not-contain-all')

		let showInAnotherTree = ['in-another-tree', 'not-in-another-tree']
			.includes(operator)

		// Toggle visibility of "in another tree" controls
		this.$('.in-another-tree').toggleClass('is-not-displayed',
			!showInAnotherTree)

		// Fixes #59382, #59324, #59396
		// Hide the entire rollup filter if none of the relevant controls
		// are displayed
		this.$('.datasets-rollup-filter').toggleClass('is-not-displayed',
			!(showContainsAnySelect || showFilterOn || showInAnotherTree))
	},

	isValuesOperator: function(operator) {
		return operator === 'contains-all' || operator === 'contains-any' ||
			operator === 'does-not-contain-all' || operator === 'does-not-contain-any'
	},

	onChangeAnotherTreeFieldIdentifier: function() {
		this.formView.change()
	},

	cleanup: function() {
		DatasetsTextFilter.prototype.cleanup.apply(this, arguments)
		this.markedField?.remove()
	},

	saveState: function() {
		DatasetsTextFilter.prototype.saveState.apply(this, arguments)
		let anotherTreeFieldIdentifier = this.$('[name=anotherTreeFieldIdentifier]').val()
		let ids = this.model.fieldIdentifierToIds(anotherTreeFieldIdentifier)
		if (ids) {
			this.options.filter.anotherTreeFieldId = ids.fieldId
			this.options.filter.anotherTreeVisibleLinkedFieldId = ids.visibleLinkedFieldId
		}
		delete this.options.filter.anotherTreeFieldIdentifier
	},

	remove: function() {
		DatasetsTextFilter.prototype.remove.apply(this, arguments)
		_.invokeMap([this.markedField], 'remove')
	}

})

export default DatasetsRollupFilterStep1

DatasetsRollupFilterStep1.__filename__ = 'datasets/filters/datasets-rollup-filter-step1.js'
